/** Short-hand for document.querySelector(element) */
export const $qs = (selector) => {
    return document.querySelector(selector);
};

/** Short-hand for document.querySelectorAll(element) */
export const $qsa = (selector) => {
    return document.querySelectorAll(selector);
};

/**
 * @method getWindowWidthSize - A method that retrieves the browser or window width
 * from the global window object.
 *
 * @return number - returns the numerical value for the browser width
 */
export const getWindowWidthSize = () => {
    const windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    return windowWidth;
};

/**
 * @method getWindowHeightSize - A method that retrieves the browser or window height
 * from the global window object.
 *
 * @return number - returns the numerical value for the browser height
 */
export const getWindowHeightSize = () => {
    const windowHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
    return windowHeight;
};

/** Make sure that an element is in the DOM depending on the requirements of a lifecycle */
export const elementLoadCheck = ($classOrId) => {
    return document.querySelector($classOrId) ? true : false;
};

/** Make sure that a group of elements are in the DOM depending on the requirements of a lifecycle */
export const elementsLoadCheck = ($classOrId) => {
    return document.querySelectorAll($classOrId) ? true : false;
};

/**
 * @method itemColorChangeSwitch - Takes a provided boolean to determine if the input colors should
 * alternate or switch on the provided HTMLObjectElement (itemObj).
 * @param {HTMLObjectElement} - a querySelected HTML Element.
 * @param {boolean} boolean - a boolean that is used to check if a condition is true or false for the color switch .
 * @param {string} color1 - initial color of itemObj.
 * @param {string} color2 - alternate color of itemObj based on boolean value itemObj.
 */
export const itemColorChangeSwitch = (itemObj, boolean, color1, color2) => {
    var index = 0;
    if (boolean) {
        for (index; index < itemObj.length; index++) {
            itemObj[index].style.color = color1;
        }
    } else {
        for (index; index < itemObj.length; index++) {
            itemObj[index].style.color = color2;
        }
    }
};

/**
 * @method createSpecialUList - Creates a unordered list that is the same kind of structure that is
 * existent in carousel indicators.
 * @param {string} listType - The type of list. Can be ul, ol, div.
 * @param {string} itemType - The type of list item. Ca be li, div, span, etc.
 * @param {string} listClass - The list class or selector.
 * @param {string} itemClass - The list items class or selector.
 * @param {number} listCount - The number of items that will be in the list
 * @param {HTMLElement} parentContainerNode - The parent container node (querySelected) for the list.
 * @return {HTMLElement} - returns a list with items as an HTML Element.
 */
export const createSpecialUList = (listType, itemType, listClass, itemClass, listCount, parentContainerNode) => {

    const parentContainer = parentContainerNode;
    const ulist = document.createElement(listType);
    const ulistItem = document.createElement(itemType);
    let returnedElements;
    ulist.setAttribute('class', listClass);
    ulistItem.setAttribute('class', itemClass);
    ulistItem.setAttribute('role', 'button');
    ulistItem.setAttribute('aria-disabled', 'true');

    for (var iz = 0; iz < listCount; iz++) {
        const y = ulistItem.cloneNode(true);
        ulist.appendChild(y);
    }
    for (var ux = 0; ux < listCount; ux++) {
        const x = ulist.cloneNode(true);
        x.children[ux].classList.add('selected');
        parentContainer[ux].appendChild(x);
    }
    returnedElements = parentContainer;

    return returnedElements;
};

/**
 * @method handleIEDetection - Identifies the Internet Explorer Version of a browser.
 * @return string - The identifying values for the browser from the user agent or simply
 * false if not an IE browser
 */
export const handleIEDetection = () => {
    var userAgent = window.navigator.userAgent;

    var msie = userAgent.indexOf('MSIE');
    if (msie > 0) {
        /* Internet Explorer 10 or older - will return the version number */
        return parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), 10);
    }

    var trident = userAgent.indexOf('Trident/');
    if (trident > 0) {
        /* Internet Explorer 11 - will return the version number */
        var versionValue = userAgent.indexOf('rv:');
        return parseInt(userAgent.substring(versionValue + 3, userAgent.indexOf('.', versionValue)), 10);
    }

    var edge = userAgent.indexOf('Edge/');
    if (edge > 0) {
        /* Internet Explorer Edge version 12 or above - will return the version number */
        return parseInt(userAgent.substring(edge + 5, userAgent.indexOf('.', edge)), 10);
    }

    // non-IE browser
    return false;
};

/** Simulate a Click based on a keycode - use for when inline access to the element is not possible.
 * @param {number & string} keyCode - the keycode or which that should trigger the click keyCode = { which: number, code: string }.
 * @param {HTMLElement} targetElement - the element that should receive the click.
 * @param {string} eventName - the key event (keyup, keypress, keydown) that should trigger the click.
 */
export const simulateClickOnEvent = (keyCode = { which: '', code: '' }, targetElement, eventName) => {

    /* Add eventListener to the targetedElement */
    targetElement.addEventListener(eventName, simClick);

    /* Helper method for simulating click based parent keycode param
    - if matching keyCode param */
    function simClick(e) {
        /* Store the key event */
        var pressedKey = e.which || e.keycode;
        if (pressedKey === parseInt(keyCode.which, 10) || pressedKey === keyCode.code) {
            e.target.click();
        }
    }
};

/** Simulate Click - used for inline assignment to event
 * @param {number & string} keyCode - the keycode or which that should trigger the click keyCode = { which: number, code: string }.
 * @param {HTMLElement} targetElement - the element that should receive the click.
 */
export const simClickLite = (e, keyCode = { which: '', code: '' }) => {
    /* Store the key event */
    var pressedKey = e.which || e.keycode;
    if (pressedKey === parseInt(keyCode.which, 10) || pressedKey === keyCode.code) {
        e.target.click();
    }
};

/**
 * @method - bridgeCarouselControlsAA.
 * Allows user to easily switch between the previous and next controls using alternate keys, when tabbing
 * is not convenient or impossible due to a carousel's design.
 * The supplemental keys are the up, down, left, and right directional keys (non-keypad).
 *
 * @param {string} prevBtnClass - previous button's className
 * @param {string} nextBtnClass - next button's className
 * @param {HTMLElement} firstSlideOrItemClass - the first item or slide class in the carousel
 * @param {e} - event
 */
/** Function that differentiates keydown event data for directional keys when either control buttons have focus */
export const bridgeCarouselControlsAA = (e, prevBtnClass, nextBtnClass, firstSlideOrItemClass) => {
    let activeControl = '';
    /* Store keycode or which data from keydown event */
    const pressedKey = e.which || e.keycode;
    /* While the previous button has focus. If up key was pressed then select the next control */
    if ((pressedKey === 38 || pressedKey === 'ArrowUp') && event.target.classList.contains(nextBtnClass)) {
        document.querySelector('.' + prevBtnClass).focus();
    }
    /* While the next button has focus. If down key was pressed then select the previous control */
    if ((pressedKey === 40 || pressedKey === 'ArrowDown') && event.target.classList.contains(prevBtnClass)) {
        document.querySelector('.' + nextBtnClass).focus();
        activeControl = 'Next Control';
    }
    /* If a first slide or item is specified give it focus when either control has focus and the user presses
    the left or right key */
    if (firstSlideOrItemClass) {
        if (pressedKey === 37 || pressedKey === 39 || pressedKey === 'ArrowLeft' || pressedKey === 'ArrowRight') {
            document.querySelector('.' + firstSlideOrItemClass).focus();
        }
    }
    return activeControl;
};

/**
 * @method getTabbingDirection - assigns the resulting value to window.shiftTabStatus which
 * can be used to identify the direction of the tabbing on the keyboard - whether forwards
 * or backwards. Before using this method window.shiftTabStatus must be identified and
 * initialized.
 * Example: window.shiftTabStatus = 'false';
 */
export const getTabbingDirection = () => {

    let shiftKeyPressed = false;

    window.addEventListener('keydown', confirmShiftTabPress);
    window.addEventListener('keyup', confirmKeyRelease);

    function confirmShiftTabPress(e) {
        /* If the pressed key is shift shiftKeyPressed is true*/
        const keyPressed = e.which || e.keycode;
        if (keyPressed === 16) {
            shiftKeyPressed = true;
            window.shiftTabStatus = 'shift-pressed-only';
        }
    }

    function confirmKeyRelease(e) {
        const releasedKey = e.which || e.keycode;
        /* If the released key is tab while the shiftKey */
        if (releasedKey === 9 && shiftKeyPressed) {
            window.shiftTabStatus = '<=BackwardTab';
        } else if (releasedKey === 9 && !shiftKeyPressed) {
            window.shiftTabStatus = 'ForwardTab=>';
        } else if (releasedKey !== 9 && !shiftKeyPressed) {
            window.shiftTabStatus = 'false';
        } else {
            window.shiftTabStatus = 'false';
        }
        if (releasedKey === 16) {
            shiftKeyPressed = false;
        }
    }
};

export const contentCleaner = (dataString) => {
    let stringInProcess;
    let cleanString;
    // remove white space from the front and ends of incoming string.
    stringInProcess = dataString.trim();
    // remove new lines and breaks from the string
    stringInProcess = stringInProcess.replace(/[\n\r]/g, " ");
    // remove odd characters that are not standard Skye Learning characters
    cleanString = stringInProcess.replace(/[^A-Za-z0-9\s()-<>_\\/.!?;'"&®@Ⓣ%©™\p{Pd}]/g, '');
    // return the cleaned string
    return cleanString;
};

export const accentCharacterCleaner = (dataString) => {
    const cleanString = dataString.replace(/[^A-Za-z0-9\s()-<>=_\\/.!?;'"&®@Ⓣ%©™\p{Pd}]/g, '');
    return cleanString;
}

export const trimContent = (dataString) => {
    let cleanString;
    // remove white space from the front and ends of incoming string.
    cleanString = dataString.trim();
    // remove new lines and breaks from the string
    cleanString = cleanString.replace(/[\n\r]/g, " ");
    // return the cleaned string
    return cleanString;
};

/** Helps for controlling component states based on whether they're visible on the screen based, depending on scroll
 * value(s).
 */
export const controlElementBasedOnScrollVisibility = (disabledCounter, elementDisabledStatus, targetElement, documentFromUserAgent, clientElement, pageOffset, action1 = () => { }, action2 = () => { }) => {
    let statusJustUpdated = false;
    pageOffset = (pageOffset > 0) ? pageOffset : 0;
    /* Will get a more accurate vertical scroll position if there is an offset from the element's parent */
    let targetElementVerticalPosition = targetElement.offsetTop + targetElement.offsetParent.offsetTop + pageOffset;

    /* Booleans that are used for blocking, since turning the element off requires an OR condition */
    let firstOffCondition = false;
    let secondOffCondition = false;

    /* If the element is not on screen and sitting (scrolled) above the top of the screen  */
    if ((targetElementVerticalPosition + targetElement.offsetHeight) < documentFromUserAgent.scrollTop && disabledCounter === 0) {
        firstOffCondition = true;
        disabledCounter++;
    }

    /* If the element is not on screen and sitting (scrolled) below the browser window screen */
    if
        ((targetElementVerticalPosition > (documentFromUserAgent.scrollTop + clientElement.clientHeight)) && disabledCounter === 0) {
        secondOffCondition = true;
        disabledCounter++;
    }

    /* If either off condition BOOLEAN first or second are true and the disabled status boolean is false then set to 1 (turn it off once).
    Can only be turned on when ON condition is true */
    if (firstOffCondition || secondOffCondition && !elementDisabledStatus && disabledCounter <= 1) {
        //action1();  // used for disabling the element via function if needed
        elementDisabledStatus = true;
        statusJustUpdated = true;
        setTimeout(function () {
            statusJustUpdated = false;
        }, 600);
    }

    /* If element's top sits below the top of the screen, or the element's bottom is above the bottom of the screen, then turn it on
    once and block until element qualifies for the contrary. Can only be turned off when OFF condition(s) is true. */
    if (
        ((targetElementVerticalPosition + targetElement.offsetHeight) > documentFromUserAgent.scrollTop) &&
        (targetElementVerticalPosition < (documentFromUserAgent.scrollTop + clientElement.clientHeight)) && elementDisabledStatus) {
        //action2(); // used for enabling the element via function if needed
        elementDisabledStatus = false;
        disabledCounter = 0;
        statusJustUpdated = true;
        setTimeout(function () {
            statusJustUpdated = false;
        }, 600);
    };

    return { status: elementDisabledStatus, disInteger: disabledCounter, hasJustUpdated: statusJustUpdated };
};

/**
 * @method getCurrentSeason - Determine the season based on the calendar and returns it as a simple string
 * @param {date} - A date object with specified date ex: new Date(year, month, day)
 * @return - string value for selected season.
 */
export const getCurrentSeason = (date) => {
    const year = date.getFullYear();
    const springStart = new Date(year, 2, 20);
    const summerStart = new Date(year, 5, 20);
    const autumnStart = new Date(year, 8, 22);
    const winterStart = new Date(year, 11, 21);
    const yearStart = new Date(year, 0, 1);
    const yearEnd = new Date(year, 12, 31);
    const today = date;
    let currentSeason = '';

    if (today >= yearStart && today <= springStart) {
        currentSeason = "winter";
    } else if (today >= winterStart && today <= yearEnd) {
        currentSeason = "winter";
    } else if (today >= springStart && today <= summerStart) {
        currentSeason = "spring";
    } else if (today >= summerStart && today <= autumnStart) {
        currentSeason = "summer";
    } else if (today >= autumnStart && today <= winterStart) {
        currentSeason = "autumn";
    } else {
        currentSeason = "spring";
    }
    return currentSeason;
};

/**
 * @method getMediaQueryMatch - Gets the media query match for the provided object that is provides as a parameter:
 * @param - an object that should look like this example
 * {mobile: "(max-width: 47.9375em)", tablet: "(min-width: 48em) and (max-width: 99.9375em)", desktop: "(min-width: 100em)"}
 *
 * @return - an object that contains booleans. True indicates a current media query match and others will read as false.
 * Changes to the boolean values are synchronous when used with scroll events.
*/
export const getMediaQueryMatch = (mediaQueryObject) => {
    const mobileMediaQuery = mediaQueryObject.mobile;
    const tabletMediaQuery = mediaQueryObject.tablet;
    const desktopMediaQuery = mediaQueryObject.desktop;
    /* Query the window object for the query matches */
    const mobile = window.matchMedia(mobileMediaQuery);
    const tablet = window.matchMedia(tabletMediaQuery);
    const desktop = window.matchMedia(desktopMediaQuery);
    /* return matches for each query in an object */
    return { mobile: mobile.matches, tablet: tablet.matches, desktop: desktop.matches };
};

/** Performs media matching for more than the three usual breaking points. */
export const getMediaQueryMatchAdv = (mediaQueryObject) => {
    const result = {};
    const mdObj = mediaQueryObject;
    const breakingPoints = Object.keys(mdObj);
    breakingPoints.forEach(breakPoint => {
        const x = mdObj[breakPoint];
        result[breakPoint] = window.matchMedia(x).matches;
    });
    return result;
}

/**
 * @method buildImageObject - this method is used for building image objects that will be appended to the body element as preloaded images.
 * @param {string} imageSrc - this is the full image path (domain + path + image name).
 * @param {integer} index - The index number(integer) assignment for the Alt attribute that is assigned to the preloaded image.
 */
export const buildImageObject = (imageSrc, index, fileName) => {
    let theImageObject = new Image(0, 0);
    theImageObject.src = imageSrc;
    theImageObject.style.position = "absolute";
    theImageObject.style.display = "none";
    theImageObject.alt = "PreLoaded Img-" + index + '-' + fileName;
    return theImageObject;
};

/** Returns the matchin key name that has a specific boolean value. 
 * @return returns 1 string value of the found key name
 */
export const filterObjForBooleanVal = (object, boolValue) => {
    let result = '';
    const values = Object.keys(object);
    values.forEach(item => { if (object[item].toString() === boolValue) { result = item; } });
    return result;
};

/**
 * Used to get actual html root or body depending on the user agent.
 */
export const getHtmlRootOrBodyFromDOM = () => {
    let rootOrBody;
    if (document.querySelector('html,body')) {
        rootOrBody = document.querySelector('html,body');
        if (window.navigator.userAgent.match(/Edge/)) {
            // IE Edge target for scrollTop
            rootOrBody = document.body;
        }
    }
    return rootOrBody;
};

export const eventCheck = (e) => {
    if (e && e.hasOwnProperty('nativeEvent')) {
        e.preventDefault();
    }
};

export const getCookie = (name) => {
    const p = new RegExp(`^${name}`);
    const c = document.cookie.split('; ').filter(item => p.test(item))[0];
    return (c !== undefined) ? c.split('=')[1] : '';
};

export const deleteCookie = (name, domain) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
};

/**
 * Detects if a browser has the doNotTrack option enabled.
 * @returns boolean
 */
export const ifDoNotTrack = () => {
    return ((window.doNotTrack && window.doNotTrack === '1') ||
        (window.navigator.doNotTrack &&
            (window.navigator.doNotTrack === '1' ||
                window.navigator.doNotTrack === 'yes')) ||
        (navigator.doNotTrack &&
            (navigator.doNotTrack === '1' ||
                navigator.doNotTrack == 'yes')) ||
        (navigator.msDoNoTrack && navigator.msDoNoTrack === '1') ||
        (window.external &&
            ('msTrackingProtectionEnabled' in window.external) &&
            window.external.msTrackingProtectionEnabled())) ? true : false;
};
